module.exports = __webpack_public_path__ + "img/Mobilier_de_jardin.7e188f9.jpg";